import asyncComponent from '../AsyncComponent';

export const AsyncSendEmail = asyncComponent(() => {
  return import('../../../features/email/SendEmailPage');
});
